import React from 'react';
import AdminLogin from '../../components/admin/AdminLogin';

const LoginAdmin = () => {
    return <AdminLogin />;
};

export default LoginAdmin;
